module.exports = __webpack_public_path__ + "static/media/se.7ab06cb8.svg";